import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=15797c0a&"
import script from "./Branches.vue?vue&type=script&lang=js&"
export * from "./Branches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15797c0a')) {
      api.createRecord('15797c0a', component.options)
    } else {
      api.reload('15797c0a', component.options)
    }
    module.hot.accept("./Branches.vue?vue&type=template&id=15797c0a&", function () {
      api.rerender('15797c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Branches.vue"
export default component.exports